const SET_RUC_STEPS = "SET_RUC_STEPS";
const SET_RUC_STEPS_PROMISE = "SET_RUC_STEPS_PROMISE";

export {
    SET_RUC_STEPS,
    SET_RUC_STEPS_PROMISE,
};
